import { Image } from "@react-pdf/renderer";
import "react-calendar/dist/Calendar.css";
const corporationReadFileToken =
  process.env.REACT_APP_AZURE_READ_CORPORATION_FILE;

function ShowClientLogo(logoUrl, style) {
  if (logoUrl) {
    return <Image style={style} src={logoUrl + corporationReadFileToken} />;
  } else {
    return null;
  }
}

export default ShowClientLogo;
